import { DynamicStandaloneBanner } from '@/components/Banner';
import { LabradorComponent } from '@/types/component';
import withDebugMetadata from '@/utils/withDebugMetadata';

const LabradorBanner: LabradorComponent = ({ type, meta }) => {
  return <DynamicStandaloneBanner {...withDebugMetadata({ type, meta })} />;
};

export default LabradorBanner;
